import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import AlertChip from '../../AlertChip';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
});

let id = 0;
function createData(date, from, message) {
    id += 1;
    return { date, from, message };
}

const rows = [
    createData('14/9', 'SC', 'Please provide more information'),
    createData('12/9', 'SC', 'Please provide more information'),
    createData('10/9', 'SC', 'Please provide more information')
];

class DiscriptionTable extends Component {
    state={
        
        headers : this.props.headers,
        data : this.props.data,
    }

    render() {
        const classes = this.props;
        return (
            <div className={classes.root}>
                <Table className={classes.table}>
                    <TableHead>
                        <TableRow>
                            {
                                this.state.headers.forEach(header => {
                                    return (<TableCell>{header}</TableCell>)
                                })
                            }

                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            this.state.headers.forEach(header => {
                                if (header == "flags") {
                                    return (<TableCell>
                                        {
                                            this.state.data[header].map(d => {
                                                return (<AlertChip
                                                    label={d.name}
                                                    color={d.color}
                                                    avatar={d.avatarD}
                                                    style={{ margin: 2 }}
                                                />)
                                            })
                                        }
                                    </TableCell>)

                                } else {
                                    return (<TableCell>{this.state.data[header]}</TableCell>)
                                }
                            })
                        }

                    </TableBody>
                </Table>
            </div>
        )
    }
}

DiscriptionTable.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DiscriptionTable);


// WEBPACK FOOTER //
// ./src/components/Entities/DescriptionTable/DiscriptionTable.js